import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent implements OnInit, OnDestroy {
  private popstateListener: () => void;

  ngOnInit(): void {
    this.preventBackNavigation();
  }
  ngOnDestroy(): void {
    this.enableBackNavigation();
  }

  private preventBackNavigation(): void {
    history.pushState(null, '', location.href);

    this.popstateListener = () => {
      history.pushState(null, '', location.href);
    };

    window.addEventListener('popstate', this.popstateListener);
  }

  private enableBackNavigation(): void {
    if (this.popstateListener) {
      window.removeEventListener('popstate', this.popstateListener);
    }
  }
}
